import { ForwardedRef, forwardRef } from 'react';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import css from './style.module.css';

export const Entry = forwardRef(function Component<T>(
  { Component = 'div', ...props }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <RootComponent
      {...props}
      Component={Component}
      baseClassName={css.root}
      ref={forwardedRef}
    />
  );
});
